// Libraries
import { Link } from "@/i18n/navigation";
import Image from "next/image";
import { useTranslations } from "next-intl";

export default function CourseCard({ course }) {
    const t = useTranslations();

    return (
        <Link href={`/course/${course.slug}`}>
            <div className="rounded-xl dark:text-white bg-gray-100 dark:bg-bgDark-840 border border-transparent dark:border-gold-900 hover:border-gold duration-150 overflow-hidden group h-full flex flex-col">
                {/* Cover */}
                <div className="flex">
                    <Image
                        src={course.socialImage}
                        alt={course.name}
                        width={1920 * 0.5}
                        height={1080 * 0.5}
                        className="object-cover"
                        style={{
                            maxWidth: "100%",
                            height: "auto",
                        }}
                    />
                </div>

                <div className="px-5 pt-5 border-t border-transparent dark:border-gold-900 group-hover:border-gold dark:group-hover:bg-bgDark-300 group-hover:bg-light-hover flex-grow relative">
                    {/* Category */}
                    <div className="absolute -mt-9 left-0 right-0 flex justify-center">
                        <div className="px-4 py-1 border border-gold dark:border-gold-900 group-hover:border-gold bg-gray-100 dark:bg-bgDark-840 dark:group-hover:bg-gold-900 group-hover:bg-light-hover rounded-full text-sm text-gold">
                            {course.productCategory === "entrepreneurs"
                                ? t("CourseCard_entrepreneuriat")
                                : t("CourseCard_developpement")}
                        </div>
                    </div>
                    {/* Title */}
                    <div className="mt-1 text-black dark:text-gold group-hover:text-gold">
                        {course.name}
                    </div>
                </div>
                {/* Infos */}
                <div className="flex justify-between items-center pt-5 px-5 pb-5 dark:group-hover:bg-bgDark-300 group-hover:bg-light-hover">
                    <div className="flex items-center gap-1 text-sm text-textSecondDark">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                        {course.duration}
                    </div>
                    <div className="flex items-center gap-1 text-sm text-textSecondDark">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-4 h-4"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                            />
                        </svg>
                        {course.instructor.firstName}{" "}
                        {course.instructor.lastName}
                    </div>
                </div>
            </div>
        </Link>
    );
}
